module.exports = __webpack_public_path__ + "img/placeholder_add.e95680fb.png";